import { convertPropClass2ClassObjectLike } from '../../core/utils/KProps'
import _ from 'lodash'

/**
 *
 */
export default {
  name: 'KDataGridRow',
  props: {
    columns: {
      type: Array,
      default() {
        return []
      },
    },
    rowIndex: {
      type: Number,
      default: 0,
    },
    rowData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      maxHeight: '',
    }
  },
  computed: {
    context() {
      let parent = this.$parent
      while (parent && !parent.dataGridId) {
        parent = parent.$parent
      }
      return parent
    },
    store() {
      return this.context.store
    },
    // stripe() {
    //   return this.context.stripe && this.rowIndex % 2 === 1
    // },
    innerSelection() {
      return (this.store && this.store.innerSelection) || []
    },
    selected() {
      return _.includes(this.innerSelection, this.rowData)
    },
    customRowClass() {
      return this.context.rowClass
    },
  },
  methods: {
    handleRowClick() {
      this.$emit('clickRow', this)
    },
    getCustomRowClass() {
      const { customRowClass } = this
      if (_.isFunction(customRowClass)) {
        return customRowClass(this.rowData, this.rowIndex)
      }
      return convertPropClass2ClassObjectLike(customRowClass)
    },
  },
  render() {
    const style = {}

    const css = _.assign(this.getCustomRowClass(), {
      'km-data-grid__row': true,
      'km-data-grid__row--selected': this.selected,
      // 'km-data-grid__row--stripe': this.stripe,
    })

    const attrs = {}

    const events = {
      click: this.handleRowClick,
    }

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      on: events,
    }

    return (
      <div {...data}>
        {_.map(this.columns, (column, colIndex) =>
          column.apiRenderCell(this.rowData, {
            rowIndex: this.rowIndex,
            colIndex,
            rowInstance: this,
          }),
        )}
      </div>
    )
  },
}
